import { cx } from '../lib/cx';

export interface SkeletonProps {
  /** CSS width, e.g. `'70%'` or `130`. */
  width?: string | number;
  /** CSS height, e.g. `11` (px) or `'22px'`. */
  height?: string | number;
  /** 5px for bars, 8px for large blocks (design-reference §6.15). */
  radius?: number;
  className?: string;
}

const dim = (v: string | number | undefined): string | undefined =>
  v === undefined ? undefined : typeof v === 'number' ? `${String(v)}px` : v;

/**
 * A single shimmer bar. Mimics the shape it replaces; the card chrome is never
 * skeletonised, only its contents (§6.15). Decorative — announce the loading
 * state on the container with `aria-busy`, not here.
 */
export function Skeleton({ width, height = 12, radius = 5, className }: SkeletonProps): React.JSX.Element {
  return (
    <span
      className={cx('ds-skeleton', className)}
      aria-hidden="true"
      style={{ display: 'block', width: dim(width), height: dim(height), borderRadius: `${String(radius)}px` }}
    />
  );
}
